import React, { useRef, useState } from "react";
import { useTranslation } from "@/langs/useTranslation";
import Modal from "@/components/Modal";
import CategoryTree from "@/containers/CompanyDevice/Category/CategoryTreeWrapper";
import { makeStyles } from "@material-ui/core/styles";
import { toast } from "@/helpers/toast";

const useModalStyles = makeStyles(() => ({
  SelectCompanyTreeModal: {
    "& .MuiDialogContent-root": {
      "& .company-tree-box": {
        marginTop: 20,
        border: "solid 1px #E9E8ED",
        height: 440,
        overflowY: "scroll",
        borderRadius: 4,
        "& .ant-tree .ant-tree-treenode .ant-tree-node-content-wrapper.ant-tree-node-selected":
          {
            backgroundColor: "transparent"
          }
      }
    }
  }
}));

const SelectCompanyTreeModal = ({
  open,
  checkStrictly = true,
  onClose,
  onConfirm
}) => {
  const { t } = useTranslation();
  const [state, setState] = useState({
    current: null,
    options: [],
    open: false
  });

  const styleClass = useModalStyles();
  const tree = useRef(null);

  const handleConfirm = () => {
    if (!state.current || state.current.length <= 0) {
      toast.info(t({ defaultMessage: "请选择指派" }));
      return;
    }
    return onConfirm?.(state.current);
  };

  const handleSelect = (checkedKeys, info) => {
    setState({
      ...state,
      current: checkedKeys,
      checkedNodes: info.node
    });
  };

  return (
    <>
      <Modal
        title={t({ defaultMessage: "指派" })}
        width={576}
        height={500}
        open={open}
        onClose={onClose}
        onConfirm={handleConfirm}
        className={styleClass.SelectCompanyTreeModal}
      >
        <CategoryTree
          ref={tree}
          showAll={false}
          showSwitch={false}
          collapse={false}
          selectable={true}
          checkStrictly={checkStrictly}
          readOnly
          checkable={false}
          onSelect={handleSelect}
        />
      </Modal>
    </>
  );
};

export default SelectCompanyTreeModal;
